import { useCallback } from "react";
import { useActiveShow } from "common-fe";
import { useTranslation } from "i18n-fe";
import { formatVenueLocalDateTime } from "../util/classDisplay";

// #2097 - a formatter for GENUINE server instants bound to the active show's
// venueTimezone. Returns (value) => string|null. When the show has no usable
// zone the formatter returns the translated "Venue timezone not set" text, so
// no scoreadmin-fe surface prints a clean, plausible Pacific time off the
// shared resolver's silent default. `options` are Intl.DateTimeFormat options
// (default: medium date + short time); pass a STABLE (module-level) object.
export default function useVenueDateTime(options) {
  const { activeShow } = useActiveShow();
  const { t } = useTranslation("scoreadmin");
  const zone = activeShow?.venueTimezone;
  const unsetText = t("venueTimezone.unset");
  return useCallback(
    (value) => formatVenueLocalDateTime(value, zone, { unsetText, options }),
    [zone, unsetText, options],
  );
}
